import { Event } from "./Event";
/**
 * Item Moving Event
 */
export class ItemMovingEvent extends Event {
    /**
     * Constructor
     * @param element element
     * @param data data
     * @param fromIndex from index
     * @param toIndex to index
     */
    constructor(element, data, fromIndex, toIndex) {
        super(element, data);
        this.fromIndex = fromIndex;
        this.toIndex = toIndex;
    }
    /**
     * Gets from index
     */
    getFromIndex() {
        return this.fromIndex;
    }
    /**
     * Gets to index
     */
    getToIndex() {
        return this.toIndex;
    }
}
//# sourceMappingURL=ItemMovingEvent.js.map